module.exports = __webpack_public_path__ + "img/breakingbad.6978a7aa.png";